// extracted by mini-css-extract-plugin
module.exports = {"container":"productCard_container__2MBE_","title":"productCard_title__JdfFA","description":"productCard_description__1OndK","price":"productCard_price__3eUZ1"};